import axios from './axiosInstance';
import { API_ROUTES } from '../constants/apiRoutes';
import { USER_TYPE } from '../constants/common';

export const founderListApi = async (params, setIsLoadingData) => {
  try {
    const res = await axios.get(API_ROUTES.USER_LIST, {
      params: {
        type: USER_TYPE.FOUNDER,
        ...params,
      },
    });
    return res;
  } catch (error) {
    setIsLoadingData(false);
    console.log(error)
  }
};

export const getUserCounts = async (params) => {
  try {
    const res = await axios.get(API_ROUTES.USER_COUNT, {
      params: { ...params },
    });
    return res;
  } catch (error) {
    console.error('Error fetching user counts:', error);
    throw error;
  }
};

export const angelListApi = async (params, setIsLoadingData) => {
  try {
    const res = await axios.get(API_ROUTES.USER_LIST, {
      params: {
        type: USER_TYPE.ANGEL_INVESTOR,
        ...params,
      },
    });
    return res;
  } catch (error) {
    setIsLoadingData(false)
    console.log(error)
  }
};

export const vcListApi = async (params, setIsLoadingData) => {
  try {
    const res = await axios.get(API_ROUTES.USER_LIST, {
      params: {
        type: USER_TYPE.VC_INVESTOR,
        ...params,
      },
    });
    return res;
  } catch (error) {
    setIsLoadingData(false)
    console.log(error)
  }
};

export const acceleratorListApi = async (params, setIsLoadingData) => {
  try {
    const res = await axios.get(API_ROUTES.USER_LIST, {
      params: {
        type: USER_TYPE.ACCELERATOR_INVESTOR,
        ...params,
      },
    });
    return res;
  } catch (error) {
    setIsLoadingData(false)
    console.log(error)
  }
};

export const suspendUserApi = async ({ userIds, reason }) => {
  try {
    const res = await axios.patch(API_ROUTES.SUSPEND_USER, {
      userIds,
      reason,
    });
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const restoreUserApi = async ({ userIds, reason }) => {
  try {
    const res = await axios.patch(API_ROUTES.RESTORE_USER, {
      userIds,
      reason,
    });
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getUserDetailApi = async (userId) => {
  try {
    const res = await axios.get(`${API_ROUTES.USER_DETAIL}${userId}`);
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateUserDetailApi = async ({ userId, data }) => {
  try {
    const res = await axios.put(
      `${API_ROUTES.UPDATE_USER}${userId}`,
      data,
    );
    return res;
  } catch (error) {
    console.error('Error updating user:', error.response?.data || error.message);
    throw error;
  }
};

export const getAdminApi = async ({ adminId, token }) => {
  try {
    const res = await axios.get(`${API_ROUTES.ADMIN_DETAIL}${adminId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  } catch (error) {
    console.error('Error fetching admin:', error.response?.data || error.message);
    throw error;
  }
};

export const updateAdminApi = async ({ adminId, data }) => {
  try {
    const res = await axios.put(
      `${API_ROUTES.ADMIN_DETAIL}${adminId}`,
      data,
    );
    return res;
  } catch (error) {
    console.error('Error updating user:', error.response?.data || error.message);
    throw error;
  }
};

export const mediaUpload = async (formData, token) => {
  try {
    const res = await axios.post(
      `${API_ROUTES.ADMIN_DETAIL}upload`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return res;
  } catch (error) {
    console.log('Error uploading media:', error.response?.data || error.message);
    throw error;
  }
};

export const reportListApi = async (params, setIsLoadingData) => {
  try {
    const res = await axios.get(API_ROUTES.REPORT_LIST, {
      params: {
        ...params,
      },
    });
    return res;
  } catch (error) {
    setIsLoadingData(false)
    console.log(error)
  }
};

export const suspendReportApi = async ({ reportId, status }) => {
  try {
    const res = await axios.patch(API_ROUTES.REPORT_SUSPEND, {
      reportId,
      status,
    });
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getReportCounts = async (params) => {
  try {
    const res = await axios.get(API_ROUTES.REPORT_COUNT);
    return res;
  } catch (error) {
    console.error('Error fetching user counts:', error);
    throw error;
  }
};

export const getReportDetailApi = async (userId) => {
  try {
    const res = await axios.get(`${API_ROUTES.REPORT_DETAIL}${userId}`);
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addTeamApi = async (data) => {
  try {
    const res = await axios.post(
      `${API_ROUTES.CREATE_TEAM}`,
      data,
    );
    return true;
  } catch (error) {
    console.error('Error updating user:', error.response?.data || error.message);
    throw error;
    return false;
  }
};

export const adminTeamListApi = async (params, setIsLoadingData) => {
  try {
    const res = await axios.get(API_ROUTES.GET_TEAM, {
      params: {
        ...params,
      },
    });
    return res;
  } catch (error) {
    setIsLoadingData(false);
    console.log(error)
  }
};

export const getSingleAdminApi = async (adminId) => {
  try {
    const res = await axios.get(`${API_ROUTES.GET_TEAM}/${adminId}`);
    return res;
  } catch (error) {
    console.error('Error fetching admin:', error.response?.data || error.message);
    throw error;
  }
};

export const updateSingleAdminApi = async ({ adminId, data }) => {
  try {
    await axios.put(
      `${API_ROUTES.GET_TEAM}/${adminId}`,
      data,
    );
    return true;
  } catch (error) {
    console.error('Error updating user:', error.response?.data || error.message);
    throw error;
  }
};

export const deleteAdminApi = async (adminId) => {
  try {
    await axios.delete(`${API_ROUTES.GET_TEAM}/${adminId}`);
    return true;
  } catch (error) {
    console.error('Error deleting admin:', error.response?.data || error.message);
    throw error;
  }
};

export const transactionListApi = async (params, setIsLoadingData) => {
  try {
    const res = await axios.get(API_ROUTES.TRANSACTION_LIST, {
      params: {
        ...params,
      },
    });
    return res;
  } catch (error) {
    setIsLoadingData(false);
    console.log(error)
  }
};

export const getSingleTransactionApi = async (id, stripePaymentId) => {
  try {
    const res = await axios.get(`${API_ROUTES.TRANSACTION_LIST}/${id}`, {
      params: { stripePaymentId },
    });
    return res;
  } catch (error) {
    console.error('Error fetching admin:', error.response?.data || error.message);
    throw error;
  }
};

export const refundAmountApi = async (data) => {
  try {
    const res = await axios.post(
      `${API_ROUTES.REFUND_AMOUNT}`,
      data,
    );
    return true;
  } catch (error) {
    console.error('Error updating user:', error.response?.data || error.message);
    throw error;
    return false;
  }
};

export const getRecentUserCount = async () => {
  try {
    const res = await axios.get(`${API_ROUTES.GET_DASHBOARD_TOTAL_USER}`);
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getRecentActivityList = async () => {
  try {
    const res = await axios.get(`${API_ROUTES.GET_RECENT_ACTIVITIES}`);
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};